import type { ContactWidget as ContactWidgetType } from '../../types/coach';
import { Avatar, Badge, Card, Icon } from '../atoms';
import { ErrorState } from '../molecules';

interface ContactWidgetProps {
  widget: ContactWidgetType;
}

export function ContactWidget({ widget }: ContactWidgetProps) {
  const { contact } = widget;

  // Defensive programming
  if (!contact) {
    return <ErrorState message="Invalid contact widget" />;
  }

  return (
    <Card variant="glass" hover className="max-w-sm">
      <div className="flex items-center space-x-3">
        <div className="flex-shrink-0">
          <Avatar 
            fallback={contact.initials ?? contact.name.charAt(0)}
            size="lg"
            src={contact.imageName ? `/images/contacts/${contact.imageName}` : undefined}
            alt={contact.name}
            className="w-12 h-12"
          />
        </div>
        <div className="flex-1 min-w-0">
          <h4 className="text-sm font-semibold text-text-primary truncate">
            {contact.name ?? 'Unknown Contact'}
          </h4>
          <p className="text-xs text-text-muted mt-1">
            {contact.phone ?? 'No phone available'}
          </p>
          <Badge 
            variant="success" 
            size="xs" 
            className="mt-2"
            icon={<Icon name="user" size="xs" />}
          >
            Contact
          </Badge>
        </div>
      </div>
    </Card>
  );
}